import {stage} from '@/constant/env';
import {LANGUAGE_LABELS} from '@/constant/language';

let locales =
  stage === 'prod'
    ? ['zh-TW', 'zh-CN', 'ja-JP', 'en-US']
    : ['zh-TW', 'zh-CN', 'ja-JP', 'en-US'];

locales = locales.map((code) => ({
  code,
  name: LANGUAGE_LABELS[code] || code,
}));

export default locales;
